import { render, staticRenderFns } from "./TourCreate.vue?vue&type=template&id=ce7a8022"
import script from "./TourCreate.vue?vue&type=script&lang=js"
export * from "./TourCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports